import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyAh2UTRmou9EKlwHWb0UdhfixDn9BdrX4M",
  authDomain: "bhanu-portfolio.firebaseapp.com",
  projectId: "bhanu-portfolio",
  storageBucket: "bhanu-portfolio.appspot.com",
  messagingSenderId: "680571001201",
  appId: "1:680571001201:web:ecbb2b49df303772cc7ed0",
  measurementId: "G-6J5D4MHXWY"
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore();